<template>
    <div>
        <div class="position-relative" id="img-bg">
            <div class="container-fluid h-100">
                <div class="row justify-content-center h-100" v-if="!isAdvancedfilters">
                    <div class="col-10 col-lg-4 align-self-center search-box">
                        <div class="row p-3 pb-lg-0 search-box__title">
                            <div class="col-12 col-md-6 search-box__title-icon">
                                <!-- <span class="me-3 px-2 btn-success rounded-2"><a href=""
                                        class="text-light">خرید</a></span>
                                <span><a href="" class="text-light">رهن و اجاره</a></span> -->
                            </div>
                            <div class="d-none d-md-block col-6 search-box__title-option">
                                <p class="text-end">
                                    <span class="text-light">گزینه های جستجو پیشرفته </span>
                                    <i class="fas fa-angle-down text-light ps-2"></i>
                                </p>
                            </div>
                        </div>
                        <div class="row p-3 pt-0 justify-content-center align-items-center search-box__body">
                            <div class="col-9 col-lg-10 p-0">
                                <input type="search" class="form-control rounded-0 rounded-start"
                                    placeholder="استان،شهر یا محله">
                            </div>
                            <div class="col-3 col-lg-2 p-0">
                                <button class="form-control rounded-0 rounded-end border-success border- color-bg-green"
                                    type="submit" id="button-addon1">جستجو</button>
                            </div>
                        </div>
                        <div class="row p-3 pt-0">
                            <div class="d-block d-md-none col-12">
                                <p class="text-center">
                                    <span class="text-light">گزینه های جستجو پیشرفته </span><i
                                        class="fas fa-angle-down text-light ps-2"></i>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container mt-5">
            <div class="row justify-content-between">
                <div class="col-lg-4">
                    <i class="fas fa-star text-success me-2"></i>
                    <span class="fw-bold h5">آپارتمان های پیشنهادی در تهران</span>
                </div>
                <div class="col-lg-2 text-end">
                    <router-link to="/realEstate" class="rounded-pill btn btn-light btn-all-top">مشاهده همه
                    </router-link>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-lg-9">
                    <div v-if="isLoading === true" class="container loading-skeleton">
                        <div class="row">
                            <div class="col-md-6" v-for="i in 4" :key="i">
                                <div class="card mb-3">
                                    <img src="//placekitten.com/300/200" class="card-img-top" alt="...">
                                    <div class="card-body">
                                        <h5 class="card-title">Card title</h5>
                                        <h5 class="card-title">Card title</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <router-link to="/realEstate" v-else class="row image-title-right">
                        <div v-for="estate in estatesLimited" :key="estate.id" class="col-lg-6 mb-4">
                            <div class="shadow mb-4 mb-lg-0 w-100" style="width: 18rem;">
                                <img v-if="estate.image.length === 0" src="../assets/images/about-us/homeplus.jpg"
                                    class="card-img-top image-estate" alt="..." title="">
                                <img v-else :src="estate.image[0].src" class="card-img-top image-estate" alt="..."
                                    title="">
                                <div class="card-body p-3">
                                    <p class="card-text fw-bold">
                                    <p class="text-dark">
                                        {{ estate.description.substring(0, 60) }}&nbsp&nbsp...
                                    </p>
                                    </p>
                                </div>
                                <div class="d-flex p-2 gap">
                                    <span v-if="estate.transaction_type" class="text-muted">
                                        {{ getTransactionType(estate.transaction_type) }}
                                    </span>
                                    <span v-if="estate.estate_type" class="text-muted">
                                        {{ getEstateType(estate.estate_type) }}
                                    </span>
                                    <span v-if="estate.direction" class="text-muted">
                                        {{ getDirection(estate.direction) }}
                                    </span>
                                    <span v-if="estate.region" class="text-muted">
                                        {{ getRegion(estate.region) }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </router-link>
                </div>

                <div class="col-12 text-center text-lg-center d-lg-none mb-4">
                    <router-link to="/realEstate" class="rounded-pill btn btn-light">مشاهده همه</router-link>
                </div>

                <div class="col-lg-3 text-center image-title-left my-5">
                    <div class="mb-4 mb-lg-5">
                        <img src="../assets/images/service/service-2.jpg" class="img-fluid shadow" alt="...">
                    </div>
                    <div class="mb-4 mb-lg-5">
                        <img src="../assets/images/service/service-3.jpg" class="img-fluid shadow" alt="...">
                    </div>
                    <div>
                        <img src="../assets/images/service/service-4.jpg" class="img-fluid shadow" alt="...">
                    </div>
                </div>
            </div>
        </div>
        <section class="bg-light" style="height:auto">
            <div class="container-fluid mt-5">
                <div class="row justify-content-between">
                    <div class="col-lg-4 text-lg-center mt-5">
                        <i class="fas fa-heart me-2 text-success"></i>
                        <span class="fw-bold h5">آژانس های VIP املاک پلاس</span>
                    </div>
                    <div class="col-lg-2 text-center text-lg-center mt-5">
                        <router-link to="/allEstate" class="rounded-pill btn btn-light btn-all-top">مشاهده همه
                        </router-link>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 mt-5 mb-5">
                        <carousel :itemsToShow="7" :wrapAround="true" :breakpoints="breakpoints">
                            <slide v-for="(image, index) in images" :key="index">
                                <img class="carousel__item" src="../assets/images/contributers/1.jpg">
                            </slide>
                            <template #addons>
                                <navigation />
                            </template>
                        </carousel>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Pagination, Navigation } from "vue3-carousel";

export default {
  name: "Index",
  data() {
    return {
      estates: [],
      breakpoints: {
        // 150 and up
        150: {
          itemsToShow: 2,
          snapAlign: "center",
        },
        // 300 and up
        300: {
          itemsToShow: 2.5,
          snapAlign: "center",
        },
        // 500 and up
        500: {
          itemsToShow: 4,
          snapAlign: "center",
        },
        // 800px and up
        800: {
          itemsToShow: 5,
          snapAlign: "center",
        },
        // 1024 and up
        1024: {
          itemsToShow: 7,
          snapAlign: "center",
        },
      },
      images: [
        "../assets/images/contributers/1.jpg",
        "../assets/images/contributers/2.jpg",
        "../assets/images/contributers/1.jpg",
        "../assets/images/contributers/2.jpg",
        "../assets/images/contributers/1.jpg",
        "../assets/images/contributers/2.jpg",
        "../assets/images/contributers/1.jpg",
        "../assets/images/contributers/2.jpg",
        "../assets/images/contributers/1.jpg",
        "../assets/images/contributers/1.jpg",
        "../assets/images/contributers/1.jpg",
        "../assets/images/contributers/1.jpg",
        "../assets/images/contributers/1.jpg",
      ],
      isLoading: true,
      isAdvancedfilters: false,
    };
  },
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
  computed: {
    estatesLimited() {
      return this.estates.splice(3, 4);
    },
  },
  methods: {
    getTransactionType(value) {
      if (value === "SALE") {
        return "خرید و فروش";
      } else if (value === "RENT") {
        return "رهن و اجاره";
      } else if (value === "PARTNERSHIP") {
        return "مشارکت";
      }
    },
    getEstateType(value) {
      if (value === "VILLA") {
        return "ویلایی";
      } else if (value === "APARTMENT") {
        return "آپارتمان";
      } else if (value === "EARTH") {
        return "زمین";
      }
    },
    getDirection(value) {
      if (value === "WEST") {
        return "غربی";
      } else if (value === "EAST") {
        return "شرق";
      } else if (value === "NORTH") {
        return "شمال";
      } else if (value === "SOUTH") {
        return "جنوب";
      }
    },
    getRegion(value) {
      return value.name;
    },
    getImage(value) {
      return value.src;
    },
  },
  mounted() {
    this.axios.get("https://api.amlakplus.app/haghi-estate").then((res) => {
      if (res.status === 200) {
        this.estates = res.data.data;
        this.isLoading = false;
      }
    });
  },
};
</script>

<style>
.carousel__slide > .carousel__item {
  transform: scale(1);
  opacity: 0.5;
  transition: 0.5s;
  width: 100px;
  cursor: pointer;
}

.carousel__slide--visible > .carousel__item {
  opacity: 1;
  transform: rotateY(0);
}

.carousel__slide--next > .carousel__item {
  transform: scale(0.9) translate(-10px);
}

.carousel__next {
  right: 10px !important;
}

.carousel__slide--prev > .carousel__item {
  transform: scale(0.9) translate(10px);
}

.carousel__prev {
  left: 10px !important;
}

.carousel__slide--active > .carousel__item {
  transform: scale(1.1);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
}

.carousel__viewport {
  padding: 20px 0 !important;
}

.btn-success {
  background-image: linear-gradient(
    to top,
    #32ccb2,
    #2ecca6,
    #29cc99,
    #22cc85
  ) !important;
}

.btn {
  border-width: 0 !important;
}

.form-control:focus {
  color: #212529;
  background-color: #fff;
  border-color: #32ccb2 !important;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 253, 141, 0.25) !important;
}
</style>